import { useEffect, useRef } from "react";

/**
 * Custom hook for auto-growing textarea based on content
 * @param value - The current textarea value
 * @returns A ref to attach to the textarea element
 */
export const useTextareaAutoGrow = (value: string) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [value]);

  return textareaRef;
};
